module.exports = __webpack_public_path__ + "static/media/Flaticon.a693eb6c.ttf";